<span class="rounded-full px-2 py-1 text-xs font-medium" [ngClass]="classes">
    <ng-content></ng-content>
  </span>
  